/* Gals Who — theme.js
   Consolidated: nav scroll shadow, scroll-reveal + stat count-up, cart (localStorage demo), mobile nav toggle
*/
document.addEventListener('DOMContentLoaded', function () {
(function(){
  var nav = document.getElementById('main-nav');
  function update(){
    nav.classList.toggle('scrolled', window.scrollY > 12);
  }
  window.addEventListener('scroll', update, {passive:true});
  update();
})();
});

(function(){
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll reveal via IntersectionObserver — animates once, ~20-25% visible */
  var targets = document.querySelectorAll('.reveal, .reveal-img, .reveal-group, .reveal-stack');
  if ('IntersectionObserver' in window && targets.length) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {threshold:0.22, rootMargin:'0px 0px -8% 0px'});
    targets.forEach(function(el){ io.observe(el); });
  } else {
    targets.forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* Statistic count-up, once visible — skipped entirely under reduced motion */
  function animateCount(el){
    var raw = el.textContent.trim();
    var m = raw.match(/^(\D*)([\d,]+(?:\.\d+)?)(.*)$/);
    if (!m || reduceMotion) return;
    var prefix = m[1], numStr = m[2].replace(/,/g,''), suffix = m[3];
    var isFloat = numStr.indexOf('.') !== -1;
    var target = parseFloat(numStr);
    if (isNaN(target)) return;
    var duration = 1100, start = null;
    function step(ts){
      if (!start) start = ts;
      var p = Math.min((ts-start)/duration, 1);
      var eased = 1 - Math.pow(1-p, 3);
      var cur = target*eased;
      el.textContent = prefix + (isFloat ? cur.toFixed(1) : Math.round(cur).toLocaleString()) + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }
  var statGroups = document.querySelectorAll('.stats-inner');
  if ('IntersectionObserver' in window && statGroups.length) {
    var statIO = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('.stat-n').forEach(animateCount);
          statIO.unobserve(entry.target);
        }
      });
    }, {threshold:0.35});
    statGroups.forEach(function(el){ statIO.observe(el); });
  }
})();

(function(){
  var STORE_KEY = 'gw_cart_v1';

  function loadCart(){
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; }
    catch(e){ return []; }
  }
  function saveCart(items){
    localStorage.setItem(STORE_KEY, JSON.stringify(items));
    renderCart();
  }
  function fmtPrice(n){ return '£' + n.toFixed(2); }

  function renderCart(){
    var items = loadCart();
    var count = items.reduce(function(sum, i){ return sum + i.qty; }, 0);
    var total = items.reduce(function(sum, i){ return sum + i.qty * i.price; }, 0);

    var badge = document.getElementById('cartBadge');
    var priceLabel = document.getElementById('cartPriceLabel');
    var totalLabel = document.getElementById('cartTotalLabel');
    var itemsWrap = document.getElementById('cartItems');
    if (!badge) return;

    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
    priceLabel.textContent = fmtPrice(total);
    totalLabel.textContent = fmtPrice(total);

    if (!items.length){
      itemsWrap.innerHTML = '<p class="cart-empty">your cart is empty</p>';
      return;
    }
    itemsWrap.innerHTML = items.map(function(i){
      return '<div class="cart-item" data-id="' + i.id + '">' +
        '<span class="cart-item-name">' + i.name + '</span>' +
        '<span class="cart-item-qty">x' + i.qty + '</span>' +
        '<span class="cart-item-price">' + fmtPrice(i.price * i.qty) + '</span>' +
        '<button class="cart-item-remove" data-id="' + i.id + '" aria-label="Remove">&times;</button>' +
      '</div>';
    }).join('');
  }

  function addToCart(item){
    var items = loadCart();
    var existing = null;
    for (var k = 0; k < items.length; k++){ if (items[k].id === item.id){ existing = items[k]; break; } }
    if (existing){ existing.qty += (item.qty || 1); }
    else { items.push({ id: item.id, name: item.name, price: item.price, qty: item.qty || 1 }); }
    saveCart(items);
  }
  function removeFromCart(id){
    saveCart(loadCart().filter(function(i){ return i.id !== id; }));
  }
  function clearCart(){ saveCart([]); }

  // exposed for product/tour pages to hook "add to cart" buttons into
  window.GWCart = { add: addToCart, remove: removeFromCart, clear: clearCart, render: renderCart };

  document.addEventListener('DOMContentLoaded', function(){
    renderCart();

    var btn = document.getElementById('cartBtn');
    var panel = document.getElementById('cartPanel');
    var closeBtn = document.getElementById('cartClose');
    if (!btn || !panel) return;

    btn.addEventListener('click', function(e){
      e.stopPropagation();
      panel.classList.toggle('open');
    });
    closeBtn.addEventListener('click', function(){ panel.classList.remove('open'); });
    document.addEventListener('click', function(e){
      if (panel.classList.contains('open') && !panel.contains(e.target) && !btn.contains(e.target)){
        panel.classList.remove('open');
      }
    });
    document.getElementById('cartItems').addEventListener('click', function(e){
      var rm = e.target.closest('.cart-item-remove');
      if (rm) removeFromCart(rm.getAttribute('data-id'));
    });
  });
})();

document.addEventListener('DOMContentLoaded', function () {
(function(){
  var hamBtn = document.querySelector('.nham');
  var mnav = document.getElementById('mobileNav');
  var overlay = document.getElementById('mnavOverlay');
  var closeBtn = document.getElementById('mnavClose');
  if (!hamBtn || !mnav || !overlay) return;
  function openMenu(){
    mnav.classList.add('open'); overlay.classList.add('open');
    hamBtn.classList.add('active'); document.body.style.overflow = 'hidden';
  }
  function closeMenu(){
    mnav.classList.remove('open'); overlay.classList.remove('open');
    hamBtn.classList.remove('active'); document.body.style.overflow = '';
  }
  hamBtn.addEventListener('click', function(){
    mnav.classList.contains('open') ? closeMenu() : openMenu();
  });
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', closeMenu);
  mnav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closeMenu(); });
})();
});
